import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "./Logo";

/**
 * Shared layout for static policy pages (privacy, terms, cookies).
 * Lightweight — no Navbar/Footer to avoid CTA distractions on legal pages.
 */
export default function PolicyLayout({ title, lastUpdated, children }) {
    return (
        <div className="min-h-screen bg-white text-slate-900">
            {/* Top bar */}
            <header className="border-b border-slate-200 bg-white/80 backdrop-blur sticky top-0 z-10">
                <div className="max-w-3xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
                    <Link to="/" className="inline-flex items-center" data-testid="policy-back-home">
                        <Logo size="md" />
                    </Link>
                    <Link
                        to="/"
                        className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        Tilbage til forsiden
                    </Link>
                </div>
            </header>

            <main className="max-w-3xl mx-auto px-6 lg:px-10 py-14 md:py-20">
                <div className="text-xs uppercase tracking-[0.2em] font-semibold text-sky-700">Juridisk</div>
                <h1 className="mt-3 font-display text-3xl md:text-5xl font-bold tracking-tight text-slate-900">
                    {title}
                </h1>
                {lastUpdated && (
                    <p className="mt-3 text-sm text-slate-500">Senest opdateret: {lastUpdated}</p>
                )}

                <article className="mt-10 prose-cleany">{children}</article>

                <div className="mt-14 pt-8 border-t border-slate-200 text-sm text-slate-500">
                    <p>
                        Spørgsmål? Skriv til{" "}
                        <a className="text-sky-700 hover:text-sky-900 font-medium" href="mailto:info@cleany.dk">
                            info@cleany.dk
                        </a>
                        .
                    </p>
                </div>
            </main>
        </div>
    );
}
